import { createContext, useContext } from 'react';

/** Ce que la session courante peut faire dans le back-office (GET /admin/moi). */
export interface AccesAdmin {
  email: string;
  nom: string | null;
  superadmin: boolean;
  support: boolean;
}

const Contexte = createContext<AccesAdmin | null>(null);

export const AccesAdminProvider = Contexte.Provider;

/** Droits de la session — disponibles sous `AdminLayout` seulement. */
export function useAccesAdmin(): AccesAdmin {
  const acces = useContext(Contexte);
  if (!acces) throw new Error('useAccesAdmin hors du back-office (AdminLayout).');
  return acces;
}
